<template>
  <div class="tw-px-6 tw-pt-10 tw-max-h-screen tw-overflow-auto">
    <div class="tw-mb-6 tw-ml-4">
      <h1 class="tw-leading-[38px] tw-tracking-wider">
        {{ $t('main.navigation.notifications') }}
      </h1>
      <el-switch
        v-model="isOnlyNewNotificationsOn"
        :active-text="$t('notifications.filters.only_new')"
        class="tw-mt-4"
        @change="handleOnlyNewChange"
      />
    </div>
    <div
      class="tw-flex tw-flex-col tw-justify-center"
      :class="notifications?.length > 0 ? 'tw-items-start' : 'tw-items-center tw-h-full'"
    >
      <template v-if="notifications?.length > 0">
        <ForeignerNotificationsNotification
          v-for="notification in notifications"
          :key="notification.id"
          :notification="notification"
          class="tw-mb-2"
        />
        <div
          v-if="hasNext"
          class="tw-ml-7 tw-my-4"
        >
          <i-button
            size="medium"
            :is-loading="isLoadingMore"
            @click="loadMore"
          >
            {{ $t('common.actions.load_more') }}
          </i-button>
        </div>
      </template>
      <template v-else-if="isOnlyNewNotificationsOn">
        {{ $t('notifications.no_unseen') }}
      </template>
      <template v-else>
        {{ $t('notifications.empty') }}
      </template>
    </div>
  </div>
</template>

<script>
import ForeignerNotificationsNotification from './ForeignerNotificationsNotification.vue';
import { mapState } from 'vuex';

export default {
  components: {
    ForeignerNotificationsNotification,
  },

  data() {
    return {
      isLoadingMore: false,
    };
  },

  computed: {
    ...mapState({
      notifications: (state) => state.v2.shared.notifications.notifications,
      hasNext: (state) => state.v2.shared.notifications.hasNext,
      notificationTypeFilter: (state) => state.v2.shared.notifications.filters.is_seen,
    }),
    isOnlyNewNotificationsOn() {
      return this.notificationTypeFilter === this.$notificationTypes.UNSEEN;
    },
  },

  watch: {
    notificationTypeFilter() {
      this.$store.commit('v2/shared/notifications/updateFilter', { field: 'page', payload: 1 });
      this.loadNotifications();
    },
  },

  mounted() {
    this.$store.commit('v2/shared/notifications/updateFilter', { field: 'is_seen', payload: this.$notificationTypes.UNSEEN });
    this.loadNotifications();
  },

  methods: {
    async loadMore() {
      this.isLoadingMore = true;

      this.$store.commit('v2/shared/notifications/updateFilter', { field: 'page', payload: this.$store.state.v2.shared.notifications.filters.page + 1 });
      await this.loadNotifications();

      this.isLoadingMore = false;
    },
    async loadNotifications() {
      return this.$store.dispatch('v2/shared/notifications/load', true);
    },
    handleOnlyNewChange() {
      this.$store.commit('v2/shared/notifications/updateFilter', { field: 'is_seen', payload: this.isOnlyNewNotificationsOn ? this.$notificationTypes.ANY : this.$notificationTypes.UNSEEN });
    },
  },
};
</script>
